import { observable, action} from 'mobx';
import Parent from './parent';
import settings from '../cultureSettings.json'
import {score, finance} from '../index'

export default class Silos extends Parent{

    @observable inputLine;
    @observable amountState;
    @observable filingStatus;

    constructor(num,capacity, name='', culture = 'None',  amount = 0, moisture = 0, waste = 0,amountState='',status='', scenario=[]){
        super(num,culture, scenario, amount, moisture, waste, status, name);
        this.totalCapacity = capacity;
        this.amountState = amountState;
        this.filingStatus = false;
        this.type = 'silo';
        this.inputLine = {
            culture: 'idle',
            lineStatus: 'idle'
        }
    }

    @action filling(culture,delta,waste,moisture){
        finance.storage.incTotal(culture, delta);
        this.amountState = 'increasing';
        this.filingStatus = true;
        super.filling(culture,delta,waste,moisture);
    }

    @action checkUnit(speed = 10){
        if(this.filingStatus){
            this.amountState = 'increased';
            this.filingStatus = false;
        }
        if(this.amountState = 'decreasing'){
            this.amountState = 'decreased'
        }
        if(this.culture !== "None") {
            finance.storage.incParam(this.culture, "cashYield", this.amount/30/24/60);
            finance.storage.incParam(this.culture, "directExpends", this.amount/30/24/60);
            finance.storage.incParam(this.culture, "indirectExpends", this.amount/30/24/60/10);
        }
        score.storage += this.amount*settings[this.culture].storage/1000;
        super.checkUnit(speed)
    }

    @action shippingFrom(speed = 10){
        super.shippingFrom(speed);
        this.amountState = 'decreasing';
    }


    // @action shippingFrom(){
    //     super.shippingFrom();
    //     if(this.culture !== "None") {
    //         finance.storage.incParam(this.culture, "cashYield", this.amount/30/24/60);
    //         finance.storage.incParam(this.culture, "directExpends", this.amount/30/24/60);
    //         finance.storage.incParam(this.culture, "indirectExpends", this.amount/30/24/60/10);
    //     }
    //     score.storage += this.amount*settings[this.culture].storage/1000;
    //
    //     if (!this.filingStatus){
    //         if(this.inputLine.culture !== 'idle'){
    //             this.amountState = 'increased';
    //             this.status = '';
    //             this.inputLine = {
    //                 culture: 'idle',
    //                 lineStatus: 'idle'
    //             }
    //         }
    //     }else{
    //         this.filingStatus = false;
    //     }
    //     if(this.active && this.amountState !== 'decreasing'){
    //         this.amountState = 'decreasing';
    //     }
    // }
}

// inputLine:{
//     culture: 'wheat',
//     lineStatus: 'clogged'
// }}

// inputLine:{
//     culture: 'corn',
//     lineStatus: 'active'
// }}



// WEBPACK FOOTER //
// ./src/shared/stores/objects/silos.js